<template>
	<div class="pages">
		<div class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill"></div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="商家名称/登录账号/神马付商户ID..." @handleSearch="handleOffset(0)"></z-search></div>
			
		</div>
		<section>
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td>{{item.id}}</td>
					<td><img width="80" :src="item.logo_url || defaultPic" /></td>
					<td>{{item.username || '--'}}</td>
					<td>
						<div  v-if="item.authorizer_appid">
							<p><b>公众号昵称：</b>{{item.nick_name}}</p>
							<p><b>APPID：</b>{{item.authorizer_appid}}</p>
							<p><b>认证主体：</b>{{item.principal_name}}</p>
							<p><b>公众号的原始ID：</b>{{item.user_name}}</p>
							<p><b>公众号类型：</b>{{item.service_type_info | serviceTypeInfo}}</p>
							<p><b>认证方式：</b>{{item.verify_type_info | verifyTypeInfo}}</p>
							<p><b>授权状态：</b>{{item.info_type | infoType}}</p>
							
						</div>
						<div v-else>未授权过公众号</div>
					</td>
					<td>{{item.phone}}</td>
					<td>
						<p class="w150" :title="item.private_key">商户ID：{{item.s_id || '未设置'}}</p>
						<p class="text-ellipsis w150" :title="item.private_key">商户私钥：{{item.private_key|| '未设置'}}</p>
						<p class="text-ellipsis w150" :title="item.public_key">商户公钥：{{item.public_key|| '未设置'}}</p>
					</td>
					<td>
						<p>微信/支付宝结算费率：{{item.rate|| '未设置'}}</p>
						<p>刷卡结算费率：{{item.car_rate|| '未设置'}}</p>
						<p>周期：T+{{item.settlement_cycle|| '未设置'}}</p>
					</td>
					<td>{{item.source_type ? '自动注册':'管理员创建'}}</td>
					<td>
						<!--{{item.status ? '正常':'关闭' }}-->
						<el-switch
						  v-model="item.status"
						  on-text="正常"
						  off-text="关闭"
						  on-color="#2BB673"
						  off-color="#ff4949"
						  @change="handleUpdateBusinessStatus(item.id, item.status)"
						  >
						</el-switch>
					</td>
					<td>{{item.c_time | momentFmt }}</td>
					<td>{{item.l_time | momentFmt }}</td>
					<td class="operating">
						<el-popover placement="top" width="200" :ref="'popover_'+index">
							<div class="z-popover">
								<div>确定要把此商家登录密码重置为初始密码888888?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleResetPwd(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-password"></i><span>重置密码</span></a>
						</el-popover>
						<router-link class="operat-btn" :to="{ name: 'businessEdit' ,query:{id:item.id}}"><i class="icon-edit"></i><span>编辑</span></router-link>
					</td>
				</tr>
				<div slot="operate">
					<router-link class="z-btn z-btn-primary b-r-3" :to="{ name: 'businessEdit'}">创建商家</router-link>
				</div>
			</z-table>

		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'BusinessManage',
		components: {},
		data() {
			return {
				defaultPic: require('@/assets/img/logo_def.png'),
				columns: ['商家ID', 'logo','商家名称','授权公众号', '登录账号', '神马付', '结算', '注册来源', '状态','创建时间','最后操作时间', '操作'],
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					search: '',//查询字符串
				}
			}
		},
		mounted() {
			this.handleGetBusinessList();
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.business.list
			})
		},
		filters: {
			serviceTypeInfo(val) {
				switch(val) {
					case 0:
						return '订阅号';
						break;
					case 1:
						return '历史老帐号升级后的订阅号';
						break;
					case 2:
						return '服务号';
						break;
					default:
						return '未知';
				}
			},
			verifyTypeInfo(val) {
				switch(val) {
					case -1:
						return '未认证';
						break;
					case 0:
						return '微信认证';
						break;
					case 1:
						return '新浪微博认证';
						break;
					case 2:
						return '腾讯微博认证';
					case 3:
						return '已资质认证通过但还未通过名称认证';
					case 4:
						return '已资质认证通过、还未通过名称认证';
					case 5:
						return '已资质认证通过、还未通过名称认证，但通过了腾讯微博认证';	
						break;
					default:
						return '未知';
				}
			},
			infoType(val) {
				switch(val) {
					case 'unauthorized':
						return '已取消授权';
						break;
					case 'updateauthorized':
						return '更新授权';
						break;
					case 'authorized':
						return '成功授权';
						break;
					default:
						return '未知';
				}
			},
		},
		/*
		 * 事件处理
		 */
		methods: {
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.handleGetBusinessList();
			},
			
			//重置密码
			async handleResetPwd(id) {
				try{
					await this.resetBusinessPwd({id}) 
					this.handleGetBusinessList()
					this.$success('操作成功')
				}catch(e){
					this.$errorMsg('操作失败')
				}
			},
			//更新商家状态
			async handleUpdateBusinessStatus(id,status) {
				try{
					await this.updateBusinessStatus({id,status})
					this.handleGetBusinessList()
					this.$success('操作成功')
				}catch(e){
					this.$errorMsg('操作失败')
				}
			},
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
			},
			//获取门店列表
			async handleGetBusinessList() {
				await this.getBusinessList(this.params)
			},
			...mapActions(['getBusinessList','resetBusinessPwd','updateBusinessStatus']),
		}
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	
</style>


// WEBPACK FOOTER //
// BusinessManage.vue?3193fe4a